// Operator paneli ko'rinishi: fon rasmi va uning sozlamalari.
//
// Rasm SERVERGA yuborilmaydi — brauzerning IndexedDB'sida, shu operator
// nomi ostida saqlanadi. Sababi: har operator o'z kompyuterida ishlaydi,
// rasm esa bir necha megabayt bo'ladi va uni serverga saqlash backend
// o'zgarishini (va qayta ishga tushirishni) talab qiladi. Shu sabab fon
// boshqa kompyuterga ko'chmaydi — bu ataylab qilingan tanlov.
//
// Yuklangan rasm saqlashdan oldin kichraytiriladi (eni 2560 px gacha, JPEG):
// 10 MB li surat ham ~500 KB ga tushadi, panel sekinlashmaydi.

const DB_NAME = 'cc_operator_panel';
const DB_VER = 1;
const STORE = 'look';
const MAX_W = 2560;
const JPEG_Q = 0.85;
export const MAX_UPLOAD = 20 * 1024 * 1024; // 20 MB dan katta faylni olmaymiz

export const PRESETS = [
  { key: 'tun', label: 'Tungi', css: 'radial-gradient(900px 600px at 12% 8%, #1e3a8a 0%, transparent 60%), radial-gradient(800px 700px at 88% 92%, #4c1d95 0%, transparent 62%), linear-gradient(160deg, #0b1220 0%, #0f172a 55%, #111827 100%)' },
  { key: 'dengiz', label: 'Dengiz', css: 'radial-gradient(900px 600px at 80% 10%, #0e7490 0%, transparent 58%), radial-gradient(700px 600px at 10% 90%, #065f46 0%, transparent 60%), linear-gradient(160deg, #06202b 0%, #0b2b3a 60%, #072027 100%)' },
  { key: 'shafaq', label: 'Shafaq', css: 'radial-gradient(800px 600px at 15% 15%, #9d174d 0%, transparent 58%), radial-gradient(900px 700px at 85% 85%, #b45309 0%, transparent 60%), linear-gradient(160deg, #1b0f1a 0%, #241019 55%, #1a0f10 100%)' },
  { key: 'orman', label: "O'rmon", css: 'radial-gradient(850px 650px at 85% 15%, #166534 0%, transparent 58%), radial-gradient(750px 600px at 10% 85%, #115e59 0%, transparent 60%), linear-gradient(160deg, #0a1512 0%, #0d1f18 58%, #0a1410 100%)' },
];

export const DEFAULTS = {
  bg: 'preset:tun',   // 'preset:<key>' yoki 'custom'
  scrim: 0.5,         // fonni qoraytirish (matn o'qilishi uchun)
  theme: 'dark',      // 'dark' | 'light' — shisha panellarning rangi
  fx: 'auto',         // 'auto' | 'lite' | 'glass' — xiralashtirish effekti
};

// "Shisha" xiralashtirish (backdrop-filter) videokartaga eng og'ir yuk: har
// aylantirishda panel ortidagi rasm qayta xiralashtiriladi. Kuchsiz
// kompyuterda panel shundan qotadi. Shuning uchun "avto" rejimda u faqat
// kuchli kompyuterda yoqiladi (8+ yadro va 8+ GB xotira).
export function isStrongDevice() {
  if (typeof navigator === 'undefined') return false;
  const cores = navigator.hardwareConcurrency || 0;
  const mem = navigator.deviceMemory; // faqat Chrome/Edge; 8 dan yuqorisini 8 deb beradi
  return cores >= 8 && (mem === undefined || mem >= 8);
}

// Haqiqatda qaysi rejim ishlaydi: 'lite' yoki 'glass'.
export function effectiveFx(look) {
  if (look.fx === 'lite' || look.fx === 'glass') return look.fx;
  return isStrongDevice() ? 'glass' : 'lite';
}

const settingsKey = (userId) => `cc_op2_look_${userId || 'anon'}`;

export function loadLook(userId) {
  try {
    const raw = localStorage.getItem(settingsKey(userId));
    if (!raw) return { ...DEFAULTS };
    const v = JSON.parse(raw);
    return {
      bg: typeof v.bg === 'string' ? v.bg : DEFAULTS.bg,
      scrim: Number.isFinite(v.scrim) ? Math.min(0.9, Math.max(0, v.scrim)) : DEFAULTS.scrim,
      theme: v.theme === 'light' ? 'light' : 'dark',
      fx: v.fx === 'lite' || v.fx === 'glass' ? v.fx : 'auto',
    };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function saveLook(userId, look) {
  try { localStorage.setItem(settingsKey(userId), JSON.stringify(look)); } catch (e) {}
}

export function presetCss(key) {
  const p = PRESETS.find((x) => x.key === key);
  return (p || PRESETS[0]).css;
}

// --- IndexedDB ---

function openDb() {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) { reject(new Error('Brauzer rasm saqlashni qo\'llamaydi')); return; }
    const req = indexedDB.open(DB_NAME, DB_VER);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error('IndexedDB ochilmadi'));
  });
}

function tx(db, mode) {
  return db.transaction(STORE, mode).objectStore(STORE);
}

export async function getBgBlob(userId) {
  try {
    const db = await openDb();
    return await new Promise((resolve) => {
      const r = tx(db, 'readonly').get(`bg_${userId || 'anon'}`);
      r.onsuccess = () => resolve(r.result || null);
      r.onerror = () => resolve(null);
    });
  } catch (e) {
    return null;
  }
}

export async function putBgBlob(userId, blob) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readwrite').put(blob, `bg_${userId || 'anon'}`);
    r.onsuccess = () => resolve(true);
    r.onerror = () => reject(r.error || new Error('Rasmni saqlab bo\'lmadi'));
  });
}

export async function deleteBgBlob(userId) {
  try {
    const db = await openDb();
    await new Promise((resolve) => {
      const r = tx(db, 'readwrite').delete(`bg_${userId || 'anon'}`);
      r.onsuccess = () => resolve(true);
      r.onerror = () => resolve(false);
    });
  } catch (e) { /* yo'q bo'lsa ham muammo emas */ }
}

// --- Rasmni kichraytirish ---

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Rasmni o'qib bo'lmadi — fayl buzuq bo'lishi mumkin"));
    img.src = url;
  });
}

// Faylni fon uchun qulay o'lchamga keltiradi. Kichraytirish foyda bermasa
// (masalan allaqachon kichik rasm) asl fayl o'zi qaytariladi.
export async function normalizeImage(file) {
  if (!file) throw new Error('Fayl tanlanmadi');
  if (!/^image\//.test(file.type || '')) throw new Error('Faqat rasm fayli (JPG, PNG, WEBP)');
  if (file.size > MAX_UPLOAD) throw new Error('Rasm 20 MB dan kichik bo\'lishi kerak');

  const url = URL.createObjectURL(file);
  try {
    const img = await loadImage(url);
    const w = img.naturalWidth || img.width;
    const h = img.naturalHeight || img.height;
    if (!w || !h) throw new Error("Rasm o'lchamini aniqlab bo'lmadi");
    const scale = Math.min(1, MAX_W / w);
    const tw = Math.max(1, Math.round(w * scale));
    const th = Math.max(1, Math.round(h * scale));

    const canvas = document.createElement('canvas');
    canvas.width = tw;
    canvas.height = th;
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    ctx.drawImage(img, 0, 0, tw, th);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_Q));
    if (!blob) return file;
    // Kichraytirishdan foyda bo'lmasa asl faylni saqlaymiz (sifat yo'qotmaslik uchun).
    if (blob.size >= file.size && scale === 1) return file;
    return blob;
  } finally {
    URL.revokeObjectURL(url);
  }
}

export const prettySize = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
